import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService, ISidebar } from './sidebar.service';
import { Subscription } from 'rxjs';
import { EstatusRequest, Usuario } from 'src/app/models/usuario';
import { PermisosModulosService } from 'src/app/shared/permisosModulo.service';
import { PermisoModulos } from 'src/app/models/permisoModulo/permisoModulo';
import { UsuariosService } from 'src/app/data/usuarios.service';
import { ProyectoService } from 'src/app/data/proyecto.service';
import { driver } from "driver.js";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  // menuItems: IMenuItem[] = menuItems;
  selectedParentMenu = '';
  viewingParentMenu = '';
  currentUrl: string;
  tipoGlobal: string;
  sidebar: ISidebar;
  subscription: Subscription;
  usuarioLogeado: Usuario;
  permisoModulos = new PermisoModulos();
  permisoModulosMarketing = new PermisoModulos();
  permisoModulosGanancias = new PermisoModulos();
  permisoModuloProyecto = new PermisoModulos();
  permisoModuloVentas = new PermisoModulos();
  permisoModuloIndicadores = new PermisoModulos();
  permisoModuloIncentivos = new PermisoModulos();
  permisoModuloBilletera = new PermisoModulos();
  permisoModuloRelacionMaquinaria = new PermisoModulos();

  permissioRoutesMenu = [];

  valorPermiso: boolean = false;
  version: number = 0;
  activeIndex: number | null = null;
  activeSubmenuIndex: number | null = null;
  usuarioInfo = new Usuario();

  isHoveredSide: boolean = false;
  isDriverActive: boolean = false;

  constructor(private router: Router, private sidebarService: SidebarService, public usuarios: UsuariosService,
    public permisoModuloService: PermisosModulosService, private proyectoService: ProyectoService) {
    this.proyectoService.startTourMarketing$.subscribe((res) => {
      console.log("startTourMarketing", res);
      //Cuando se aplica el tour se abre el menu afuerzas si ya esta abierto o no
      this.isHoveredSide = true;
      this.sidebarService.changeSidebarStatus(true);
      this.activeIndex = null;
      this.activeSubmenuIndex = null;

      setTimeout(() => {
        // Asegúrate de cerrar el submenú al terminar el tour
        const submenu = document.querySelector('#tour-marketing-submenu');
        console.log("submenu", submenu);
        if (submenu) { // Si el submenú está visible
          //Validar si el submenu esta abierto tour-marketing-submenu-menu si no esta abierto se hace clic en el arrow-proyect-marketing,puedo validar con activeIndex
          const submenuMenu = document.querySelector('#tour-marketing-submenu-menu');
          console.log("submenuMenu", submenuMenu);
          if (this.activeIndex != 1) { // Si el submenú está visible
            const arrowElement = document.querySelector('.arrow-proyect-marketing') as HTMLElement;
            if (arrowElement) {
              arrowElement.click(); // Cerrar el submenú
              console.log("Submenú cerrado al finalizar el tour.");
            }
          }
        }
      }, 1000);

      /* if (!this.isHoveredSide) {
        this.isHoveredSide = true;
        console.log("isHoveredSide", this.isHoveredSide);
        this.sidebarService.changeSidebarStatus(true);

        // Siempre activar el índice 1 independientemente del estado actual
        this.setActive(1);
        console.log("activeIndex", this.activeIndex);

        setTimeout(() => {
          // Siempre intentar hacer clic en el segundo arrow-proyect (índice 1)
          const arrows = document.querySelectorAll('.arrow-proyect') as NodeListOf<HTMLElement>;
          console.log("arrows", arrows);

          if (arrows.length > 1) { // Asegurarse que existe el segundo elemento
            const marketingArrow = arrows[1]; // Seleccionar el segundo arrow (índice 1)
            if (marketingArrow && marketingArrow.offsetParent !== null) {
              marketingArrow.click();
              console.log("Se hizo clic en el arrow de marketing:", marketingArrow);
            } else {
              console.error("El arrow de marketing está oculto o no es interactuable.");
            }
          } else {
            console.error("No se encontró el arrow de marketing en el DOM.");
          }
        }, 500);
      } */

      setTimeout(() => {
        this.startTutorial();
      }, 1000);
      /* 
            if (!this.isHoveredSide) {
              this.isHoveredSide = true;
              console.log("isHoveredSide", this.isHoveredSide);
              this.sidebarService.changeSidebarStatus(true);
              if (this.activeIndex != 1) {
                this.setActive(1);
                console.log("activeIndex", this.activeIndex);
                setTimeout(() => {
                  // Verifica que el elemento está presente y visible antes de hacer clic
                  const arrow = document.querySelectorAll('.arrow-proyect') as NodeListOf<HTMLElement>;
                  console.log("arrow", arrow);
                  if (arrow.length > 0) {
                    const arrowElement = arrow[0];
                    if (arrowElement && arrowElement.offsetParent !== null) {  // Verifica si el elemento está visible
                      arrowElement.click();
                      console.log("Se hizo clic en el primer elemento:", arrowElement);
                    } else {
                      console.error("El primer elemento está oculto o no es interactuable.");
                    }
                  } else {
                    console.error("No se encontró ningún elemento .arrow-proyect en el DOM.");
                  }
                }, 500);
              }
            } */

    });
  }


  cerrarMenuTutorial() {
    // Asegúrate de cerrar el submenú al terminar el tour
    const submenu = document.querySelector('#tour-marketing-submenu');
    if (submenu) { // Si el submenú está visible
      const arrowElement = document.querySelector('.arrow-proyect-marketing') as HTMLElement;
      if (arrowElement) {
        arrowElement.click(); // Cerrar el submenú
        this.activeIndex = null;
        console.log("Submenú cerrado al finalizar el tour.");
      }
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.isDriverActive) { // Si Driver.js no está activo
      this.isHoveredSide = true;
      this.sidebarService.changeSidebarStatus(true);
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (!this.isDriverActive) { // Si Driver.js no está activo
      this.isHoveredSide = false;
      this.sidebarService.changeSidebarStatus(false);
    }
  }

  // Método para establecer el elemento principal activo
  setActive(index: number) {
    console.log("setActive", index);
    this.activeSubmenuIndex = null; // Resetear el submenú activo al cambiar el elemento principal
    this.activeIndex = index;
  }

  // Método para establecer el submenú activo y mantener el elemento principal activo
  setActiveSubmenu(index: number, parentIndex: number) {
    this.activeSubmenuIndex = index;
    this.activeIndex = parentIndex; // Asegura que el padre también esté activo
  }

  ngOnInit(): void {

    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"));
    this.version = Math.floor(Math.random() * 1000000000);
    this.recuperaInfoUsuario();

    const arrow = document.querySelectorAll('.arrow-proyect') as NodeListOf<HTMLElement>;
    arrow.forEach(arrowElement => {
      arrowElement.addEventListener('click', (e: Event) => {
        const target = e.target as HTMLElement;
        const arrowParent = target.parentElement?.parentElement; // Seleccionar el padre principal de la flecha
        if (arrowParent) {
          arrowParent.classList.toggle('showMenu');
        }
      });
    });
  }

  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
  }

  hassPermission<Boolean>(permisoModulo: string = "") {
    var fd;
    if (permisoModulo) {
      fd = this.permisoModuloService.recuperaPermisoModuloUsuarios<PermisoModulos>(permisoModulo.toString());
    }
    return true;
  }

  recuperaInfoUsuario() {
    this.usuarios.recuperaUsuarioInfoV2(this.usuarioLogeado).subscribe(
      res => {
        this.usuarioInfo = res[0];
      },
      err => {
        console.error(`An error occurred: ${err.message}`);
      }
    );
  }

  regresarPortal() {
    window.location.href = "https://portal.reda.mx/";
  }

  startTutorial() {
    this.isDriverActive = true;

    const driverObj = driver({
      showProgress: true,
      showButtons: ['next', 'previous', 'close'],
      allowClose: false, // Evita cerrar por clic fuera o ESC; solo la tacha
      steps: [
        {
          element: '#tour-marketing-menu',
          popover: {
            title: 'Sección de Marketing',
            description: 'Sección general donde se organiza todo el contenido del proyecto.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            }
          }
        },
        {
          element: '#tour-Campana-submenu',
          popover: {
            title: 'Sección de Campañas',
            description: 'Crea campañas que te permitirán contactar a tus prospectos a través de diferentes canales como WhatsApp, Facebook, entre otros.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-WhatsApp-submenu',
          popover: {
            title: 'Sección de WhatsApp',
            description: 'Conecta las líneas de WhatsApp que usarás para atender a tus prospectos.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            }
          }
        },
        {
          element: '#tour-remarketing-submenu',
          popover: {
            title: 'Sección de Remarketing',
            description: 'Aquí podrás cargar y organizar todo el contenido visual y promocional de tu proyecto. Sube imágenes, videos y materiales para mostrarlos a prospectos en diferentes canales.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-medios-contacto-submenu',
          popover: {
            title: 'Sección de Medios de contacto',
            description: 'Aquí podrás agregar los medios por los que llegan tus prospectos, como WhatsApp, llamadas o mensajes. Esto te ayudará a identificar cómo se están comunicando contigo y a organizar mejor tu seguimiento.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-motivos-cancelacion-submenu',
          popover: {
            title: 'Sección de Motivos de descarte',
            description: 'Aquí puedes registrar las razones por las que un prospecto decide no continuar. Esto te ayudará a entender por qué se pierden oportunidades y a mejorar tu proceso de venta.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-bodyperson-submenu',
          popover: {
            title: 'Sección de Body Person',
            description: 'Aquí podrás cargar preguntas sobre el perfil, intereses y motivos de tu cliente ideal. Esta información te ayudará a comprender mejor a tu audiencia y construir un análisis FODA más enfocado y útil.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-tiendas-menu',
          popover: {
            title: 'Sección de Tiendas',
            description: 'Aquí puedes crear y configurar la tienda en línea de tu proyecto. Personaliza tu ecommerce para mostrar productos, servicios o propiedades, y permite que tus prospectos exploren todo desde un solo lugar.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            },
          }
        },
        {
          element: '#tour-finanzas-menu',
          popover: {
            title: 'Sección de Finanzas',
            description: 'Consulta y organiza la información de ventas de tu proyecto.Aquí podrás ver cuánto has vendido, revisar detalles de cada transacción y llevar un mejor control de tus ingresos.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            }
          }
        },
        /* {
          element: '#tour-crm-menu',
          popover: {
            title: 'Regresa al portal',
            description: 'En esta sección podrás regresar al portal.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            }
          },
        }, */
        /* {
          element: '#tour-incentivos-menu',
          popover: {
            title: 'Configura tus incentivos',
            description: 'En esta sección podrás configurar tus incentivos para tus asesores.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);
            }
          }
        }, */
        {
          element: '#tour-gestion-usuarios-menu',
          popover: {
              title: 'Sección de Usuarios',
            description: 'Crea, edita y gestiona a los usuarios que tendrán acceso a tu proyecto.',
            side: "bottom",
            align: 'start',
            nextBtnText: 'Siguiente',
            prevBtnText: 'Anterior',
            onCloseClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);

              this.cerrarMenuTutorial();
              this.terminaTourProyecto();
            },
            onNextClick: () => {
              driverObj.destroy();
              this.isDriverActive = false;
              this.isHoveredSide = false;
              this.sidebarService.changeSidebarStatus(false);

              this.cerrarMenuTutorial();
              this.terminaTourProyecto();
            }
          }
        }


      ]
    });
    setTimeout(() => {
      driverObj.drive();
    }, 500);
  }

  terminaTourProyecto() {
    var estatusRequest = new EstatusRequest();
    estatusRequest.idUsuario = this.usuarioLogeado.idUsuario;
    estatusRequest.idModulo = 2;
    estatusRequest.idEstatus = 1;

    this.usuarios.terminaTourProyecto(estatusRequest).subscribe(data => {
      if (data != null) {
        console.log("Termina tour proyecto", data);
      }
    });
  }

}
